import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Header.css';
import { Button, Container } from 'react-bootstrap';
import { FaHome, FaBars } from "react-icons/fa";
import instance from '../../services/endpoint';
import img from '../../images/Bitstek-Advisory.jpg';
import { toast } from 'react-toastify';
import Loader from "../utilComponents/loader.js"
import { MdCurrencyExchange } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";


const AdminHeader = ({ page }) => {
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
    const [darkMode, setDarkMode] = useState(true);
    const [showDropdown, setShowDropdown] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = "Admin Dashboard | Bitstek Advisory"; // Set the document title
        const timer = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString());
        }, 3000);

        return () => clearInterval(timer);
    }, []);


    const [userData, setUserData] = useState({
        FullName: "",
        AccountID: "",
    });

    const fetchUserData = async () => {
        try {
            const response = await instance.get("/api/v1/admin/auth/profile");
            setUserData({
                FullName: response.data.FullName,
                AccountID: response.data.AdminID
            });
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    const handleLogout = async () => {
        setLoading(true);
        try {
            await instance.post("/api/v1/admin/auth/logout");
            toast.success("Logout successful");
            navigate("/adminlogin");
        } catch (error) {
            console.error("Error during logout:", error);
            toast.error("An error occurred. Please try again.");
        }finally{
            setLoading(false);
        }
    };

    const navigate = useNavigate();

    return (
        <Container
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: "50px",
    backgroundColor: "black",
    zIndex: 1100,
    maxWidth: "100vw",
  }}
>
            {loading && <Loader />}
            <header className={`header ${darkMode ? 'dark' : 'light'}`}>
                <div className="header-content">
                    <div className="logo" title="Bitstek Advisory Solutions"
                    onClick={() => navigate("/admindashboard")} style={{ cursor: "pointer" }}>
                        <img
                            src={img} 
                            alt="Bitstek Advisory Logo"
                            width={100}
                            className="logo-image"
                        />
                    </div>
                    <div className='Head-name'>
                    <span className="logo-text">Bitstek Advisory</span>
                    </div>
                    <div className="actions">
                        {page === 'register' || page === 'login' ? (
                            <div className="time">{currentTime}</div>
                        ) : page === 'dashboard' ? (
                            <div className="profile-menu">
                                <button
                                    className="profile-button"
                                    onClick={() => setShowDropdown(!showDropdown)}

                                >
                                    <FaBars /></button>
                                {showDropdown && (
                                    <div className="dropdown">
                                        <div className="text-center dropdown-main">
                                            <img
                                                src={img}
                                                alt="Bitstek Advisory Logo"
                                            />
                                            <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>
                                                Hi, {userData.FullName}
                                            </h5>
                                            <hr/>
                                            <div className="flex align-items-center justify-content-center text-center">
                                                <div className="mb-2 justify-content-center align-items-center">
                                                   <div> <strong className="me-2">Account ID</strong> </div>
                                                   <div>
                                                    <p className="mb-0">{userData.AccountID}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-wrap justify-content-center mb-3">
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/adminprofile")}
                                            >
                                                <FaUserTie size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>Profile</p>
                                            </div>
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/admindashboard")}
                                            >
                                                <FaHome size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>Dashboard</p>
                                            </div>
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/currexadmindashboard")}
                                            >
                                                <MdCurrencyExchange size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>CurrexDashboard</p>
                                            </div>
                                            
                                        </div>
                                        <div className="text-center">
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                style={{ fontSize: "13px" }}
                                                onClick={handleLogout}
                                            >
                                                Logout
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
            </header>
        </Container>
    );
};

export default AdminHeader;